/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';


export interface AbbreviatedForumTopicRequest {

    id?: string;

    title?: string;

    fancy_title?: string;

    slug?: string;

    posts_count?: string;

    reply_count?: string;

    highest_post_number?: string;

    image_url?: string;

    created_at?: string;

    last_posted_at?: string;

    bumped?: string;

    bumped_at?: string;

    unseen?: string;

    pinned?: string;

    unpinned?: string;

    visible?: string;

    closed?: string;

    archived?: string;

    bookmarked?: string;

    liked?: string;

    views?: string;

    like_count?: string;

    has_summary?: string;

    archetype?: string;

    last_poster_username?: string;

    category_id?: string;

    pinned_globally?: string;

    featured_link?: string;

    /**
     * Short excerpt of the post content
     */
    summary?: string;

}

@Model('AbbreviatedForumTopic')
export class ApiAbbreviatedForumTopic extends BaseModel implements AbbreviatedForumTopicRequest {

    
    
    id: string;

    
    
    title: string;

    
    
    fancy_title: string;

    
    
    slug: string;

    
    
    posts_count: string;

    
    
    reply_count: string;

    
    
    highest_post_number: string;

    
    
    image_url: string;

    
    
    created_at: string;

    
    
    last_posted_at: string;

    
    
    bumped: string;

    
    
    bumped_at: string;

    
    
    unseen: string;

    
    
    pinned: string;

    
    
    unpinned: string;

    
    
    visible: string;

    
    
    closed: string;

    
    
    archived: string;

    
    
    bookmarked: string;

    
    
    liked: string;

    
    
    views: string;

    
    
    like_count: string;

    
    
    has_summary: string;

    
    
    archetype: string;

    
    
    last_poster_username: string;

    
    
    category_id: string;

    
    
    pinned_globally: string;

    
    
    featured_link: string;

    /**
     * Short excerpt of the post content
     */
    
    
    summary: string;

}
